import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {EnvApiData} from "./EnvApiData";

@Injectable({providedIn: 'root'})
export class EnvService{

  public authData: EnvApiData;

  constructor(private httpBackend: HttpBackend)
  {  }

  appInit(): Observable<any>{
    const httpClient = new HttpClient(this.httpBackend);
    return httpClient.get("/portal/v1/config/environment");
  }

  public getProxyURL(authData:EnvApiData) {
    return "/portal/proxy/";
  }

}



